module.exports = __webpack_public_path__ + "static/media/Sleep-Study.18d86d34.jpg";